<label class="d-control-input__label" v-if="inputLabel" :for="id">{{ inputLabel }}<span class="is-required" v-if="isRequired">&#42;</span></label>